module.exports = __webpack_public_path__ + "img/photo.f2a69d6f.svg";